// const domain = 'http://xiaoyugan.org'
// const domain2 = 'http://xiaoyugan.org'
// export const domain = '//apartment.cmentech.com'
// export const domain2 = '//apartment.cmentech.com'
const domain = ''
const domain2 = ''

export const masterUserUrl = domain + '/auth_service'
export const masterurl = domain2 + '/student_apartment'

export const collectorUrl = 'http://127.0.0.1:8918'

// 测试地址
// export const fingerUrl = 'http://testrd.cmentech.com:8210'
// 线上地址
export const fingerUrl = 'http://api.cmentech.com:8210'



// WEBPACK FOOTER //
// ./src/common/ajax/config.js